import _ from "lodash";

export default function versionedLocalStorageKey(key) {
  return `${process.env.REACT_APP_NAME}_${cleanAppVersion()}__${key}`;
}

function cleanAppVersion() {
  return _.replace(process.env.REACT_APP_VERSION, RegExp("\\.", "g"), "-");
}
